export class Post {
    public _id:String;
    public title: String;
    public description:String;
    public image:String;
    public date:Date;
    public docs : String;
    constructor(){}
  }
  